export default "__VITE_ASSET__p75$ZJ8n__"